import useQueryUrlParam from 'core/hooks/useQueryUrlParam';
import DgPagination from 'styles/UI/Pagination/DgPagination';
import DgTable, { IDgTable } from 'styles/UI/Table/DgTable';
import { useUserInvoiceTableQuery } from '../hooks/react-query/useUserInvoiceTableQuery';
import UserInvoiceTableColumn from './UserInvoiceTableColumn';
import { FC } from 'react';

interface IUserInvoiceTable extends IDgTable {
	limit?: number;
}

const UserInvoiceTable: FC<IUserInvoiceTable> = () => {
	const { data: invoices, isFetching: isFetchingInvoices } = useUserInvoiceTableQuery();
	const { query, handlePagination } = useQueryUrlParam();

	return (
		<>
			<DgTable
				rowKey='transaction_id'
				columns={UserInvoiceTableColumn()}
				dataSource={invoices?.data?.list}
				count={invoices?.data.pagination.total}
				loading={isFetchingInvoices}
				current={invoices?.data.pagination.current_page}
				per_page={query?.per_page}
			/>

			<DgPagination
				onPaginationHandler={handlePagination}
				responsive={true}
				per_page={query?.per_page}
				current={invoices?.data.pagination.current_page}
				total={invoices?.data.pagination.total}
			/>
		</>
	);
};

export default UserInvoiceTable;
